import { listReport } from './WashingHistoryByDay/WashingHistory.i18n.en'

export const washingHistory = {
  listReport,
}
